import getQrCodeService from "@/services/QrCodeService";
import mutationTypes from "./mutation-types";
import { ProjectAuthType } from "@/typings/AuthType";

const load = async ({ commit, dispatch }, id) => {
    const qrcodeService = getQrCodeService();

    try {
        const qrcodeObject = await qrcodeService.loadQrCode(id);
        const videoUrl = await getQrCodeService().computeVideoUrl(qrcodeObject);
        const audioUrl = await getQrCodeService().computeAudioUrl(qrcodeObject);
        const { html, fullHtml, scripts } = getQrCodeService().computeCustomHtmlContent(
            qrcodeObject
        );

        if (qrcodeObject.project.authTypeId === ProjectAuthType.REQUIRED) {
            dispatch("auth/logout", { keepStorage: true }, { root: true });
        }
        const webarurl = await getQrCodeService().getWebArUrl(qrcodeObject.project.id,videoUrl);

        commit(mutationTypes.SET_QRCODE_OBJECT, qrcodeObject);
        commit(mutationTypes.SET_VIDEO_URL, videoUrl);
        commit(mutationTypes.SET_AUDIO_URL, audioUrl);
        commit(mutationTypes.SET_CURRENT_PHOTOS, qrcodeObject.currentPhotos);
        commit(mutationTypes.SET_CUSTOM_HTML, html);
        commit(mutationTypes.SET_CUSTOM_FULL_HTML, fullHtml);
        commit(mutationTypes.SET_CUSTOM_JS, scripts);
        commit(mutationTypes.SET_WEBAR_URL,webarurl || "");
    } catch (e) {
        let title = "";
        let text = "";
        let qrCodeBanned  = false;
        switch (e.response?.data?.code) {
            case "EBADREQUEST":
                title = "errors.qrcodeNotFoundTitle";
                text = "errors.qrcodeNotFoundText";
                break;

            default:
                title = "errors.serverErrorTitle";
                text = "errors.serverErrorText";
        }
        if(e.response?.data.code === 65 || e.response?.data.description === "Shortlink is banned"){
            qrCodeBanned = true;
        }
        dispatch("displayError", { title, text, isBanned:qrCodeBanned} );
    }
};

const logScan = async ({ commit }, { fp, project, shortlink, action }) => {
    await getQrCodeService().logScan(fp, project, shortlink, action);
};

const displayError = ({ commit }, { title, text , isBanned}) => {
    commit(mutationTypes.RAISE_QRCODE_ERROR, { title, text , isBanned:isBanned});
};

const clearError = ({ commit }) => {
    commit(mutationTypes.CLEAR_ERROR);
};

export default {
    load,
    logScan,
    clearError,
    displayError
};
